import { useMutation } from '@tanstack/react-query';

import { useAccountsService } from '@restworld/data-services';

function useCheckUserExistenceMutation() {
  const accountsService = useAccountsService();

  const mutation = useMutation({
    mutationFn: ({ email, phoneNumber }: CheckUserExistenceParams) =>
      accountsService.checkUserExistence({ email, phone_number: phoneNumber }),
  });

  return mutation;
}
export default useCheckUserExistenceMutation;

interface CheckUserExistenceParams {
  phoneNumber?: string;
  email?: string;
}
